import axios from 'axios'
import * as Sentry from '@sentry/vue'

export const apiCallReal = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  const headerByDefault = { 'Content-Type': 'application/json' }
  const headers = { ...headerByDefault, ...extraHeader }
  const endpoint = process.env.VUE_APP_API_URL + url
  return new Promise((resolve, reject) => {
    axios({ url: endpoint, data, method, headers })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        Sentry.captureException(error)
        reject(error)
      })
  })
}

export const getResource = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  const headerByDefault = { 'Content-Type': 'application/json' }
  const headers = { ...headerByDefault, ...extraHeader }
  return new Promise((resolve, reject) => {
    axios({ url, data, method, headers })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        Sentry.captureException(error)
        reject(error)
      })
  })
}

export const apiCall = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  return apiCallReal({ url, method, data, extraHeader })
}

export default {apiCall}



// WEBPACK FOOTER //
// ./src/utils/api.js